import { quickProperty, designToken } from '../component-tokens';
import { borderBase } from './common';
const listItem = {
    name: 'item',
    tag: 'li',
    attributes: {
        display: quickProperty('flex'),
        cursor: quickProperty('pointer'),
        'flex-direction': quickProperty('column'),
        'align-items': quickProperty('center'),
        color: designToken('text-02'),
    },
    children: [
        {
            name: 'icon',
            tag: 'svg',
            content: '[ICON-SVG_HOME_INACTIVE]',
            attributes: {
                width: quickProperty('20px'),
                'pointer-events': quickProperty('none'),
            },
        },
        {
            name: 'text',
            tag: 'span',
            content: 'Home',
            attributes: {
                font: designToken('caption-small-02'),
            },
        },
    ],
};
export const bottomNavigationTokens = {
    name: 'bottom-navigation',
    tag: 'ul',
    reactImports: 'BottomNavigation',
    attributes: Object.assign(Object.assign({}, borderBase), { 'border-color': designToken('border'), 'list-style': quickProperty('none'), margin: quickProperty('0'), padding: quickProperty('0'), height: quickProperty('56px'), display: quickProperty('flex'), 'justify-content': quickProperty('space-around'), 'align-items': quickProperty('center') }),
    description: `Bottom navigation bars allow users to navigate quickly through the main sections of an app on mobile devices.`,
    children: [listItem],
    variants: [
        {
            tag: 'ul',
            name: 'selected',
            children: [
                Object.assign(Object.assign({}, listItem), { attributes: Object.assign(Object.assign({}, listItem.attributes), { color: designToken('icon-01') }), children: [
                        Object.assign({}, listItem.children[0]),
                        listItem.children[1],
                    ] }),
            ],
        },
    ],
};
